import { render, staticRenderFns } from "./PosicionamentoDados.vue?vue&type=template&id=5c07a5cc"
import script from "./PosicionamentoDados.vue?vue&type=script&lang=js"
export * from "./PosicionamentoDados.vue?vue&type=script&lang=js"
import style0 from "./PosicionamentoDados.vue?vue&type=style&index=0&id=5c07a5cc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports